<template>
  <div class="users__list">
    <ul>
      <li v-for="(item, index) in items" v-bind:key="item.id" @click.stop="item.edit=true">
        <div class="users__list__item">
          <div v-if="!item.edit" class="name"><span>{{item.name}}</span></div>
          <input v-if="item.edit" name="name" type="text" placeholder="Name" v-model="item.name" @keyup.enter="save(item)" />
          <div v-if="!item.edit" class="email"><span>{{item.email}}</span></div>
          <input class="email" v-if="item.edit" name="email" type="text" placeholder="Email" v-model="item.email" @keyup.enter="save(item)" />
          <div v-if="!item.edit" class="tenant"><span>{{item.tenant}}</span></div>
          <select style="width: 20%" v-if="item.edit" name="tenant" v-model="item.tenantId" v-validate="'required'">
            <option></option>
            <option v-for="tenant in tenants" v-bind:key="tenant.id" :value="tenant.id">{{tenant.name}}</option>
          </select>
          <div class="actions">
            <button v-if="item.edit" style="margin-left: 10px" class="button" title="Close" @click.stop="item.edit=false"><i class="material-icons">close</i></button>
            <button v-if="item.edit" title="Save" class="button save" @click="save(item)"><i class="material-icons">save</i></button>
            <button v-if="!item.edit" class="button save" title="rename project" @click.stop="item.edit=true"><i class="material-icons">edit</i></button>
            <button class="button delete" title="Delete" @click.stop="user=item,showConfirm()"><i class="material-icons">delete</i></button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'list',
    props: ['items'],
    data: () => ({
      user: null
    }),
    computed: {
      ...mapGetters(['tenants'])
    },
    methods: {
      ...mapActions(['deleteUser', 'saveUser']),
      showConfirm() {
        const options = {title: `DELETE USER`, cancelLabel: 'NO', okLabel: 'YES'}
        this.$dialogs.confirm(`Do you really want to delete the user: ${this.user.name.toUpperCase()}?`, options)
        .then(res => {
          if (res.ok) {
            this.deleteUser(this.user)
          }
        })
      },
      save: function(item) {
        let findTenant = this.tenants.find((tenant) => {
          return tenant.id === item.tenantId
        });

        if (findTenant) {
          item.tenant = findTenant.name
        }

        this.saveUser(item).then(() => {
          item.edit = false
        });
      },
    }
}
</script>